import { gql } from '@apollo/client'

export const FIND_MANY_CUSTOMER_ACCOUNT = gql`
  query FindManyCustomerAccount($customerId: Int!) {
    findManyCustomerAccount(where: { customerId: { equals: $customerId } }) {
      id
      createdAt
      updatedAt
      customerId
      email
      name
      notes
      customerSubAccountId
      customerSubAccount {
        id
        name
        createdAt
        _count {
          customerAccounts
        }
      }
    }
  }
`

export const FIND_UNIFIED_CUSTOMER_ACCOUNTS_AND_LOCATIONS = gql`
  query FindUnifiedCustomerAccountsAndLocations($customerId: Int!) {
    findManyCustomerAccount(where: { customerId: { equals: $customerId } }) {
      id
      createdAt
      updatedAt
      customerId
      email
      name
      notes
      customerSubAccountId
      status
      customerSubAccount {
        id
        name
        createdAt
        _count {
          customerAccounts
        }
      }
    }
    findManyCustomerSubAccount(where: { customerId: { equals: $customerId } }) {
      id
      createdAt
      updatedAt
      name
      customerId
      _count {
        customerAccounts
      }
    }
  }
`

export const FIND_UNIQUE_CUSTOMER_ACCOUNT = gql`
  query FindUniqueCustomerAccount($id: String!) {
    findUniqueCustomerAccount(where: { id: $id }) {
      id
      createdAt
      updatedAt
      customerId
      password
      email
      name
      notes
      customerSubAccountId
    }
  }
`

export const CREATE_ONE_CUSTOMER_ACCOUNT = gql`
  mutation CreateOneCustomerAccount(
    $customerId: Int!
    $email: String!
    $password: String
    $name: String
    $notes: String
    $customerSubAccountId: Int
  ) {
    createOneCustomerAccount(
      data: {
        customerId: $customerId
        customerSubAccountId: $customerSubAccountId
        email: $email
        password: $password
        name: $name
        notes: $notes
      }
    ) {
      id
      createdAt
      updatedAt
      customerId
      email
      name
      notes
    }
  }
`

export const UPDATE_ONE_CUSTOMER_ACCOUNT = gql`
  mutation UpdateB2BCustomerAccount(
    $id: String!
    $email: String!
    $password: String!
    $notes: String
    $customerSubAccountId: Int
    $name: String
  ) {
    updateB2BCustomerAccount(
      where: { id: $id }
      email: $email
      password: $password
      notes: $notes
      customerSubAccountId: $customerSubAccountId
      name: $name
    ) {
      id
      createdAt
      updatedAt
      customerId
      email
      name
      notes
      customerSubAccountId
    }
  }
`

export const FIND_ALL_CUSTOMER_ACCOUNTS = gql`
  query FindAllCustomerAccounts(
    $searchTerm: String
    $take: Int
    $skip: Int
    $filters: [CustomerAccountWhereInput!]
    $orderBy: [CustomerAccountOrderByWithRelationInput!]
  ) {
    findManyCustomerAccount(
      where: {
        AND: [
          {
            OR: [
              { email: { contains: $searchTerm, mode: insensitive } }
              { name: { contains: $searchTerm, mode: insensitive } }
            ]
          }
          { AND: $filters }
        ]
      }
      take: $take
      skip: $skip
      orderBy: $orderBy
    ) {
      id
      createdAt
      updatedAt
      customerId
      email
      name
      notes
      status
      customerSubAccountId
      customer {
        id
        account_code
        name
        surname
        b2b_company_name
      }
      customerSubAccount {
        id
        name
        createdAt
        _count {
          customerAccounts
        }
      }
    }
    findManyCustomerAccountCount(
      where: {
        AND: [
          {
            OR: [
              { email: { contains: $searchTerm, mode: insensitive } }
              { name: { contains: $searchTerm, mode: insensitive } }
            ]
          }
          { AND: $filters }
        ]
      }
    )
  }
`

export const DELETE_ONE_CUSTOMER_ACCOUNT = gql`
  mutation DeleteOneCustomerAccount($id: String!) {
    deleteOneCustomerAccount(where: { id: $id }) {
      id
    }
  }
`

export const DELETE_MANY_CUSTOMER_ACCOUNTS = gql`
  mutation DeleteManyCustomerAccounts($ids: [String!]!) {
    deleteManyCustomerAccount(where: { id: { in: $ids } }) {
      count
    }
  }
`

export const CUSTOMER_ACCOUNT_SEND_INVITATION = gql`
  mutation CustomerAccountSendInvitation($id: String!) {
    customerAccountSendInvitation(id: $id) {
      id
      email
      status
    }
  }
`
